import {Component} from '@angular/core';
import {MatDivider} from "@angular/material/divider";
import {ActivatedRoute, Router} from "@angular/router";
import {ProductsService} from "@services/products/products.service";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-products-list',
  imports: [
    MatDivider,
    MatProgressBar,
    MatButton,
  ],
  templateUrl: './products-list.component.html',
  standalone: true,
  styleUrl: './products-list.component.scss'
})
export class ProductsListComponent {
  displayedProducts: any[] = [];
  pageSize = 10;
  currentPage = 1;
  hasMoreProducts = false;
  isLoading = false;

  mapApplicationTime = [
    'MORNING', 'EVENING'
  ];

  constructor(
    private productsService: ProductsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.loadInitialProducts();
  }

  loadInitialProducts() {
    this.currentPage = 1;
    this.displayedProducts = [];
    this.fetchProductsPage(this.currentPage);
  }

  loadMoreProducts() {
    if (this.isLoading) return;
    this.currentPage++;
    this.fetchProductsPage(this.currentPage);
  }

  fetchProductsPage(page: number) {
    this.isLoading = true;
    this.productsService.fetchProductsPaginated(page, this.pageSize)
      .subscribe({
        next: (res: any) => {
          const products = res.products || [];
          this.displayedProducts = [...this.displayedProducts, ...products];
          this.hasMoreProducts = this.displayedProducts.length < res?.metadata?.total_records;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  openProduct(product: any) {
    // Implementation for opening product details
  }

  openAddNew() {
    this.router.navigate(['add-new'], {relativeTo: this.route});
  }
}
